<template>
  <main>
    <div class="container-fluid">

      <!-- ALERTA -->
      <div v-if="avisoGeral">
        <b-alert show variant="warning">
          <span class="font-weight-bold">
            {{ mensagemAviso }}
          </span>
        </b-alert>
      </div>

      <!-- BOTÕES SUPERIORES -->
      <div class="row justify-content-end mb-3">
        <botaoSuperior 
          v-for="botao in botoesTopoDireitoExibidos"
          :key="botao.titulo"
       
          :titulo="botao.titulo"
          :descricao="botao.descricao"
          :image="$baseUrl(botao.image)"
          :textoAlternativo="botao.titulo"
          :destaque="botao.destaque"
          :funcao="botao.funcao"
        />
      </div>

      <!-- TÍTULO -->
      <div class="mb-5 px-md-2 w-md-50">
        <h1 class="text-justify titulo">
          Sistema de emissão de DRAM (Documento de Recolhimento e Arrecadação
          Municipal) da Prefeitura de Belo Horizonte
        </h1>

        <h2 v-if="contexto.publico" class="text-justify subtitulo text-muted">
            Devido a restrições impostas pela LGPD (Lei Geral de Proteção de Dados),
            para que a identificação completa do contribuinte conste nas guias emitidas
            é necessário clicar na opção "ACESSO IDENTIFICADO" exibida acima.
            Sem a identificação, as guias serão exibidas com asteriscos em alguns campos.
        </h2>
      </div>

      <!-- PRINCIPAIS SERVIÇOS -->
      <h3 class="text-center mt-5">PRINCIPAIS SERVIÇOS OFERECIDOS</h3>

      <div class="row px-md-5">
        <botaoTelaInicial
          v-for="servico in pricipaisServicosExibidos"
          :key="servico.titulo"
          :titulo="servico.titulo"
          :descricao="servico.descricao"
          :link="servico.link"
          :textoAlternativo="servico.titulo"
          :image="$baseUrl(servico.image)"
        />
      </div>

      <!-- OUTROS SERVIÇOS -->
      <h3 class="text-center mt-5">OUTROS SERVIÇOS OFERECIDOS</h3>

      <div class="row px-md-5">
        <botaoTelaInicial
          v-for="servico in outrosServicosExibidos"
          :key="servico.titulo"
          :titulo="servico.titulo"
          :descricao="servico.descricao"
          :link="servico.link"
          :external="servico.external"
          :textoAlternativo="servico.titulo"
          :image="$baseUrl(servico.image)"
        />
      </div>

    </div>
  </main>
</template>

<script>
import botaoTelaInicial from "../components/botaoTelaInicial.vue";
import botaoSuperior from "../components/botaoSuperior.vue";
import constantes from "../constants/index";

export default {
  name: "teste",
  components: {
    botaoSuperior,
    botaoTelaInicial,
  },

  data() {
    return {
      origemAcesso: "",
      userName: "",
      avisoGeral: false,
      mensagemAviso: "",

      casosExigenciaPermissaoAutorizadosUsuario: [],
      casosDeUsoQueExigemPermissaoAcesso: ["USC.21.020", "USC.21.014", "USC.21.015", "USC.21.012", "USC.21.011"]
    };
  },
      ///
      // USC.21.003   -  IPTU
      // USC.21.001  -   GERAR DRAM
      // USC.21.008   -  GERAR DRAM DE ITBI POR TRANSAÇÃO / CONFISSÃO DO ISSQN  - ITBI
      // USC.21.014   -  DRAM POR ARQUIVO TXT
      // USC.21.005   -  CADASTRO E-MAIL
      // USC.21.006   -  RELATÓRIO DE DÉBITOS DO DRAM
      // USC.21.004   -  RELATÓRIO DE DÉBITOS PROTESTADOS
      // USC.21.007   -  ALTERAÇÃO DE ENDEREÇO CORRESPONDÊNCIA DE IMÓVEL
      // USC.21.010   -  ALTERAÇÃO DE ENDEREÇO DO IMÓVEL
      // USC.21.012   -  PROTESTO - EMISSÃO DE DRAM E CDAP
      // USC.21.015   -  CONFISSÃO DE DÉBITOS ISSQN
      // USC.21.020   -  FAIXA FAC AR
      ///  
  watch: {
    situacao: {
      immediate: true,
      handler(novoValor) {
        if (novoValor === 'AVISO') {
          this.avisoGeral = true
          this.mensagemAviso = this.mensagem
        } else {
          this.avisoGeral = false
          this.mensagemAviso = null
        }
      }
    }
  },


  methods: {
    /// VERIFCA SE TEM PERMISSAO Acesso
    temPermissaoAcesso(casoDeUso) {
      return this.casosExigenciaPermissaoAutorizadosUsuario.includes(casoDeUso);
    },
    ///

    login() {
      const redirectUri = `${window.envJson.redirect_uri}${process.env.VUE_APP_BASE_URL}`;
      this.$store.getters.keycloak.login({ redirectUri });
    },

    extratoDebito() {
      const redirectUri = `${window.envJson.redirect_uri}${process.env.VUE_APP_BASE_URL}gerar_dram`;
      this.$store.getters.keycloak.login({ redirectUri });
    },
    goToFAQ() {
      this.$router.push({ name: "USC.21.009" });
    },
    /// VERIFCA SE TEM PERMISSAO Acesso
    async verificaPermissaoAcesso(casoDeUso) {
      let permite = false;
      await this.$axios
        .post(this.$env.url_backend + constantes.casosPermissaoAcesso, {
          listaCasoUso: [casoDeUso],
          usuario: this.userName,
        })
        .then((response) => {
          const retorno = response.data;
          permite = retorno;
        })
        .catch(() => {
          return false;
        });
      return permite === true || permite?.permite === true;
    },    
  },

  async beforeMount() {
    this.origemAcesso = this.$store.getters.userInfo.origem;
    this.userName = this.$store.getters.userInfo.preferred_username; 

    this.casosExigenciaPermissaoAutorizadosUsuario = []; 
    if (this.origemAcesso === 'AD') {
      try {
        /// RETORNA TODOS OS CASOS QUE TEM PERMISSAO Acesso PARA O USUARIO
        await this.$axios
          .post(this.$env.url_backend + constantes.casosPermissaoAcesso, {
            listaCasoUso: this.casosDeUsoQueExigemPermissaoAcesso,
            usuario: this.userName,
          })
          .then((response) => {
              this.casosExigenciaPermissaoAutorizadosUsuario = response.data;
          })
      } catch (error) {
        console.error("Erro ao verificar permissao:", error);
      }
    } 
  },

  computed: {
    contexto() {
      return {
        GovBr: this.origemAcesso === 'GovBr',
        AD: this.origemAcesso === 'AD',
        // publico: this.origemAcesso !== 'GovBr' && this.origemAcesso !== 'AD',
        publico: true,
        temPermissaoAcesso: this.temPermissaoAcesso
      }
    },

        /* =========================
       BOTÕES SUPERIORES
    ========================== */
    botoesTopoDireito() {
      return [
        {
          titulo: "ACESSO IDENTIFICADO",
          descricao:
            "Consulta e emite DRAM por CPF e CNPJ.",
          image: "icons/IDENTITY.svg",
          destaque: true,
          funcao: this.login,
          exibir: (item) => !item.GovBr && !item.AD
        },
        {
          titulo: "PERGUNTAS FREQUENTES",
          descricao: null,
          image: "icons/FAQ.svg",
          destaque: false,
          funcao: this.goToFAQ,
          exibir: () => true
        }
      ]
    },

    botoesTopoDireitoExibidos() {
      return this.botoesTopoDireito.filter(item =>
        item.exibir(this.contexto)
      )
    },

    /* =========================
       SERVIÇOS PRINCIPAIS
    ========================== */
    pricipaisServicos() {
      return [
        {
          titulo: this.anoAtual,
          descricao: "Emitir DRAM de IPTU/Taxas Imobiliárias do exercício corrente, usando apenas o identificador índice cadastral",
          link: "iptu",
          image: "icons/HOME.svg",
          exibir: () => true
        },
        {
          titulo: "GERAR DRAM",
          descricao: "Emite DRAM para débitos inscritos ou não em dívida ativa",
          link: "gerar_dram",
          image: "icons/CERTIFICATE.svg",
          exibir: () => true
        },
        {
          titulo: "EXTRATO DE DÉBITOS",
          descricao: "Emite DRAM e consulta detalhes do lançamento",
          link: "gerar_dram",
          image: "icons/CERTIFICATE.svg",
          exibir: () => true
        },        
        {
          titulo: "DRAM POR ARQUIVO TXT",
          descricao: "Geração do DRAM através de upload de arquivo txt",
          link: "pagamento_arquivo",
          image: "icons/CERTIFICATE.svg",
          exibir: (item) =>
            item.AD && item.temPermissaoAcesso('USC.21.014')
        }
      ]
    },

    pricipaisServicosExibidos() {
      return this.pricipaisServicos.filter(item =>
        item.exibir(this.contexto)
      )
    },

    /* =========================
       OUTROS SERVIÇOS
    ========================== */
    outrosServicos() {
      return [
        {
          titulo: "BOLETO DE CUSTAS E EMOLUMENTOS",
          descricao:
            "Este serviço/consulta exibe somente os débitos protestados pela Prefeitura de Belo Horizonte.",
          link:
            "https://bhresolve.cartoriosdeprotestodebh.com.br/limpanome",
          image: "icons/CERTIFICATE.svg",
          external: true,
          exibir: (item) => item.publico
        },

        // {
        //   titulo: "CADASTRO E-MAIL",
        //   descricao: "Cadastra email para recebimento de DRAM",
        //   link: "cadastro_email",
        //   image: "icons/MAIL.svg",
        //   exibir: (item) => item.GovBr || item.AD
        // },

        {
          titulo: "RELATÓRIO DE DÉBITOS DO DRAM",
          descricao:
            "Emite relatório com os lançamentos inseridos no DRAM, por meio do seu número",
          link: "relatorio_debitos_dram",
          image: "icons/NOTE.svg",
          exibir: () => true
        },

        {
          titulo: "RELATÓRIO DE DÉBITOS PROTESTADOS",
          descricao:
            "Emite relatório com informações sobre débitos protestados",
          link: "relatorio_debitos_protestados",
          image: "icons/NOTE.svg",
          exibir: (item) => item.GovBr || item.AD
        },

        {
          titulo: "ALTERAÇÃO DE ENDEREÇO CORRESPONDÊNCIA DE IMÓVEL",
          descricao:
            "Altera endereço de correspondência de imóvel",
          link: "alteracao_endereco_correspodencia",
          image: "icons/EDIT_MESSAGE.svg",
          exibir: (item) => item.GovBr
        },

        {
          titulo: "ALTERAÇÃO DE ENDEREÇO DO IMÓVEL",
          descricao:
            "Acesse aqui para alterar o endereço do imóvel",
          link: "alteracao_endereco_imovel",
          image: "icons/EDIT_MESSAGE.svg",
          exibir: (item) => item.GovBr
        },

        {
          titulo: "PROTESTO - EMISSÃO DE DRAM E CDAP",
          descricao:
            "Cartórios, acesse aqui para emissão do DRAM.",
          link: "emissao-divida-ativa-cartorios-de-protesto",
          image: "icons/NOTE.svg",
          exibir: (item) =>
            item.AD && item.temPermissaoAcesso('USC.21.012')
        },

        {
          titulo: "CONFISSÃO DE DÉBITOS ISSQN",
          descricao:
            "Inclui novas confissões, Reemite guias para pagamento, Reemite termo de confissão",
          link: "confissao_issqn",
          image: "icons/CERTIFICATE.svg",
          exibir: (item) =>
             item.GovBr ||
            (item.AD && item.temPermissaoAcesso('USC.21.015'))
        },

        {
          titulo: "FAIXA FAC AR",
          descricao:
            "Cadastrar faixa de postagem de AR",
          link: "postagem_faixa_AR",
          image: "icons/CERTIFICATE.svg",
          exibir: (item) =>
            item.AD && item.temPermissaoAcesso('USC.21.020')
        }
      ]
    },

    outrosServicosExibidos() {
      return this.outrosServicos.filter(item =>
        item.exibir(this.contexto)
      )
    },
////      
    anoAtual() {
      const UM_DIA = 86400000;
      const hoje = new Date();
      const proximoDia = new Date(hoje.getTime() + UM_DIA);

      return `IPTU ${proximoDia.getFullYear()}`;
    },

    ambiente() {
      return window.envJson.environment;
    },

    sigla() {
      return process.env.MIX_APP_SIGLA || process.env.VUE_APP_SIGLA;
    },
    versao() {
      return process.env.MIX_APP_VERSAO || process.env.VUE_APP_VERSAO;
    },

    situacao() {
      return this.$store.state.situacao
    },
    mensagem() {
      return this.$store.state.mensagem
    }
  },
};
</script>

<style scoped>
.titulo {
  font-size: 1.5rem;
}

.subtitulo {
  font-size: 1.2rem;
}
</style>